export const SET_MODAL_TYPE = 'SET_MODAL_TYPE';
export const SET_IS_MODAL_OPEN = 'SET_IS_MODAL_OPEN';
export const SET_MODAL_CONFIRM_ACTION = 'SET_MODAL_CONFIRM_ACTION';
export const SET_MODAL_ALERTING_MESSAGE = 'SET_MODAL_ALERTING_MESSAGE';
export const SET_SHOW_NATIONAL_SURVEY_PROMPT = 'SET_SHOW_NATIONAL_SURVEY_PROMPT';
export const SET_MODAL_CONFIRM_ACTION_CALLBACK = 'SET_MODAL_CONFIRM_ACTION_CALLBACK';
